import React, { useMemo } from 'react'
import { useFetch } from 'use-http'

import { Box, Card, Heading, Image, Stack, Text } from '@myxplor/stardust'

import sortObjectsBy from '~/src/utils/sortObjectsBy'

import LoadingLoop from '~/src/components/LoadingLoop'

import homeImage from '~/src/assets/home.png'
import playgroundImage from '~/src/assets/playground.png'

const Packages = () => {
  const featureRequest = useFetch('/api/v1/features', {}, [])
  const featureSetRequest = useFetch('/api/v1/feature_sets', {}, [])

  const featureLookup = useMemo(() => {
    const features = (featureRequest.data?.data || []) as Papi.Feature[]
    return features.reduce((acc, feature) => {
      return { ...acc, [feature.id]: feature }
    }, {}) as Record<number, Papi.Feature>
  }, [featureRequest.data])

  const featureSets = useMemo(() => {
    const featureSets = (featureSetRequest.data?.data || []) as Papi.FeatureSet[]
    return sortObjectsBy(featureSets, 'name')
  }, [featureSetRequest.data])

  if (featureRequest.loading || featureSetRequest.loading) {
    return <LoadingLoop />
  }

  if (featureRequest.error || featureSetRequest.error) {
    return <div>Error...</div>
  }

  return (
    <Stack space="small">
      <Box alignItems="center" display="flex" justifyContent="space-between" width={1}>
        <Heading level={4}>Packages</Heading>
      </Box>
      <Text lineHeight={1.4}>
        To prevent accidentally causing issues for customers, you cannot create or modify packages from this
        screen. If you need to create or modify a package, ask a friendly engineer to make the changes in the
        database.
      </Text>
      {featureSets.map((featureSet) => {
        const setFeatures = featureSet.toggles.map((toggle) => featureLookup[toggle.feature_id])
        const sortedSetFeatures = sortObjectsBy(setFeatures, 'name')
        return (
          <Card key={featureSet.id}>
            <Stack space="none">
              <Box padding="small">
                <Heading level={6}>{featureSet.name}</Heading>
              </Box>
              {sortedSetFeatures.map((feature) => (
                <Box
                  key={feature.id}
                  alignItems="center"
                  borderColor="lowestEmphasis"
                  borderTop="1px solid"
                  display="flex"
                  justifyContent="space-between"
                  paddingX="small"
                  paddingY="xxsmall"
                  width={1}>
                  <Stack space="none">
                    <Text prefab="body" weight="bold">
                      {feature.name}
                    </Text>
                    <Text prefab="bodyAlt">{feature.description}</Text>
                  </Stack>
                  <Box minHeight={32} minWidth={32}>
                    <Image
                      height={32}
                      width={32}
                      src={feature.product === 'home' ? homeImage : playgroundImage}
                    />
                  </Box>
                </Box>
              ))}
            </Stack>
          </Card>
        )
      })}
    </Stack>
  )
}

export default React.memo(Packages)
